import {Injectable} from '@angular/core';


@Injectable()
export class BrowserService {

  constructor() {

  }

  getBrowserInfo() {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: 'Opera', version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1]
    };
  }

  isIE() {
    if (this.getBrowserInfo().name.indexOf('IE') >= 0) {
      return true;
    } else {
      return false;
    }
  }

  isChrome() {
    if (this.getBrowserInfo().name.indexOf('Chrome') >= 0) {
      return true;
    } else {
      return false;
    }
  }

  isEdge() {
    if (this.getBrowserInfo().name.indexOf('Edge') >= 0) {
      return true;
    } else {
      return false;
    }
  }

  isOpera() {
    if (this.getBrowserInfo().name.indexOf('Opera') >= 0) {
      return true;
    } else {
      return false;
    }
  }

  isFirefox() {
    if (this.getBrowserInfo().name.indexOf('Firefox') >= 0) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/browser.service.ts